import type { Arealplan } from '@origo/planregister';
import type { PlanInfoFormValues } from '../types';

export function toPlanInfoFormValues(plan: Arealplan): PlanInfoFormValues {
    return {
        plannavn: plan.plannavn,
        plantype: plan.plantype,
        planstatus: plan.planstatus,
        lovreferanse: plan.lovreferanse,
        // Domain har ikke `beskrivelse` — feltet i UI er informativt for nå.
        beskrivelse: '',
    };
}

export function applyPlanInfoFormToArealplan(plan: Arealplan, values: PlanInfoFormValues): Arealplan {
    return {
        ...plan,
        plannavn: values.plannavn,
        plantype: values.plantype as Arealplan['plantype'],
        planstatus: values.planstatus as Arealplan['planstatus'],
        lovreferanse: values.lovreferanse as Arealplan['lovreferanse'],
        // beskrivelse droppes — ikke i domain.
    };
}
